var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect } from 'react';
import { changeLanguage, getLanguageFlag, getLanguageName } from './utils';
import { i18n } from '../i18n';
import config from '../config';
import { useToggle } from '../../small-tools/use-toggle';
// TODO delete me when real toggle is implemented
var LanguageSelector = function () {
    var canShow = useToggle(false);
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(i18n.language), currentLanguage = _b[0], setCurrentLanguage = _b[1];
    useEffect(function () {
        if (window.localStorage.getItem('squire_i18n_testing') === 'true') {
            canShow.setOn();
        }
    }, []);
    useEffect(function () {
        var handleLanguageChanged = function () {
            setCurrentLanguage(i18n.language);
        };
        i18n.on('languageChanged', handleLanguageChanged);
        return function () {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, []);
    // Generate languages array from config
    var languages = config.LANGUAGES.map(function (code) { return ({
        code: code,
        name: getLanguageName(code),
        flag: getLanguageFlag(code),
    }); });
    var handleLanguageChange = function (languageCode) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changeLanguage(languageCode)];
                case 1:
                    _a.sent();
                    setIsOpen(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error changing language:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleToggleDropdown = function () {
        setIsOpen(!isOpen);
    };
    if (!canShow.isOn) {
        return null;
    }
    var currentLang = languages.find(function (lang) { return lang.code === currentLanguage; }) || languages[0];
    return (_jsxs("div", { style: {
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            zIndex: 1000,
        }, children: [_jsxs("div", { style: {
                    position: 'relative',
                    display: 'inline-block',
                }, children: [_jsxs("button", { onClick: handleToggleDropdown, style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 12px',
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }, children: [_jsx("span", { style: { fontSize: '16px' }, children: currentLang.flag }), _jsx("span", { children: currentLang.name }), _jsx("span", { style: { fontSize: '12px' }, children: "\u25BC" })] }), isOpen && (_jsx("div", { style: {
                            position: 'absolute',
                            bottom: '100%',
                            left: '0',
                            marginBottom: '8px',
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                            minWidth: '120px',
                            zIndex: 1001,
                        }, onClick: function (e) {
                            // Prevent clicks inside dropdown from bubbling up
                            e.stopPropagation();
                        }, children: languages.map(function (language) { return (_jsxs("button", { onClick: function (e) {
                                e.stopPropagation();
                                handleLanguageChange(language.code);
                            }, style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '100%',
                                padding: '8px 12px',
                                backgroundColor: language.code === currentLanguage ? '#f0f0f0' : 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                textAlign: 'left',
                            }, onMouseEnter: function (e) {
                                e.currentTarget.style.backgroundColor = language.code === currentLanguage ? '#f0f0f0' : '#f8f8f8';
                            }, onMouseLeave: function (e) {
                                e.currentTarget.style.backgroundColor = language.code === currentLanguage ? '#f0f0f0' : 'transparent';
                            }, children: [_jsx("span", { style: { fontSize: '16px' }, children: language.flag }), _jsx("span", { children: language.name })] }, language.code)); }) }))] }), isOpen && (_jsx("div", { style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999,
                }, onClick: function () {
                    setIsOpen(false);
                } }))] }));
};
export default LanguageSelector;
